import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { toggleModalDiagramClone, diagramClone } from '../../../redux/main/main.actions';
import { selectIsModalDiagramCloneEnabled, selectModalDiagramCloneData } from '../../../redux/main/main.selectors';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalDiagramClone.scss';

export const ModalDiagramClone = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const buildName = (title = '') => t('m_diagram_clone.copy_of_title', { title });

    const isOpen = useSelector(selectIsModalDiagramCloneEnabled);
    const modalData = useSelector(selectModalDiagramCloneData);

    const [page, setPage] = useState('');

    const inputRef = useRef(null);
    const [value, setValue] = useState(buildName(modalData?.diagram?.title) || '');

    useEffect(() => {
        setPage(modalData?.page);

        if (!modalData?.diagram?.title) return;

        if (value !== buildName(modalData?.diagram?.title)) {
            setValue(buildName(modalData?.diagram?.title));
        }

        return () => { };
    }, [modalData]);

    const handleSave = () => {
        trackEvent('app_modal_diagram_clone_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(diagramClone(modalData?.diagram?.id, value));
        dispatch(toggleModalDiagramClone(null));

        setTimeout(() => {
            setValue(buildName(modalData?.diagram?.title));
            setPage('');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramClone(null));
        setTimeout(() => {
            setValue(buildName(modalData?.diagram?.title));
            setPage('');
        }, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        }
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-clone ${page}`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{t('m_diagram_clone.header')}</div>
            <div className="modal-content-body">

                <div className="description-text">{t('m_diagram_name.enter_new_name')}</div>

                <input
                    maxLength="1000"
                    ref={inputRef}
                    autoComplete="off"
                    spellCheck="false"
                    type="text"
                    id="diagram-name"
                    placeholder={t('m_diagram_name.enter_new_name')}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                />

                {/* <div className="description-text">Share it with the same people</div> */}

                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>{t('b.cancel')}</button>
                    <button onClick={() => handleSave()}>{t('b.duplicate')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramClone;
